import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

var _span, _span2, _span3;

var _excluded = ["isOpen", "sx"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { forwardRef } from 'react';
import Flex from '../Flex';
import Box from '../Box';
var Hamburger = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isOpen = _ref.isOpen,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: ref,
    sx: _objectSpread({
      variant: isOpen ? 'hamburger.opened' : 'hamburger.closed',
      transition: 'background-color .25s ease-in',
      height: 64,
      width: 64,
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    }, sx)
  }, rest), /*#__PURE__*/React.createElement(Box, {
    sx: {
      variant: isOpen ? 'hamburgerInner.opened' : 'hamburgerInner.closed',
      position: 'relative',
      width: '24px',
      height: '18px',
      transform: 'rotate(0deg)',
      transition: '.3s ease-in-out',
      span: {
        variant: isOpen ? 'hamburgerBar.opened' : 'hamburgerBar.closed',
        display: 'block',
        position: 'absolute',
        height: '2px',
        width: '100%',
        opacity: 1,
        transform: 'translateX(0)',
        transition: 'transform .25s ease-in, opacity .25s ease-in'
      },
      'span:nth-of-type(1)': _objectSpread({
        variant: 'hamburgerBar.closed',
        top: 0
      }, isOpen ? {
        transform: 'translateX(200%)',
        variant: 'hamburgerBar.opened',
        opacity: 0
      } : {}),
      'span:nth-of-type(2)': _objectSpread(_objectSpread({
        variant: 'hamburgerBar.closed',
        top: 'calc(( 100% / 2 ) - 1px )'
      }, isOpen ? {
        variant: 'hamburgerBar.opened',
        transform: 'rotate(-45deg)'
      } : {}), {}, {
        '&:after': _objectSpread({
          variant: 'hamburgerBar.closed',
          content: '""',
          display: 'block',
          position: 'absolute',
          height: '2px',
          width: '100%',
          opacity: 0,
          left: 0,
          transform: 'rotate(0) translateX(0)',
          transition: 'opacity .25s ease-in, transform .25s ease-in'
        }, isOpen ? {
          variant: 'hamburgerBar.opened',
          transform: 'rotate(90deg)',
          opacity: 1
        } : {})
      }),
      'span:nth-of-type(3)': _objectSpread({
        variant: 'hamburgerBar.closed',
        bottom: 0
      }, isOpen ? {
        variant: 'hamburgerBar.opened',
        transform: 'translateX(200%)',
        opacity: 0
      } : {})
    }
  }, _span || (_span = /*#__PURE__*/React.createElement("span", null)), _span2 || (_span2 = /*#__PURE__*/React.createElement("span", null)), _span3 || (_span3 = /*#__PURE__*/React.createElement("span", null))));
});
Hamburger.displayName = 'Hamburger';
export default Hamburger;